import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { handleActions } from 'redux-actions';
import { fetchAvailableBadges, fetchAvailableBadgesSuccess, awardingBadge, awardBadgeSuccess, awardBadgeFail } from './actionCreators';
import { reduxKey } from './constants';
const handler = handleActions({
    [awardingBadge.toString()]: (state, action)=>{
        return _object_spread_props(_object_spread({}, state), {
            isAwarding: true,
            errorMsg: undefined
        });
    },
    [awardBadgeSuccess.toString()]: (state, action)=>{
        return _object_spread_props(_object_spread({}, state), {
            isAwarding: false,
            errorMsg: undefined
        });
    },
    [awardBadgeFail.toString()]: (state, action)=>{
        return _object_spread_props(_object_spread({}, state), {
            isAwarding: false,
            errorMsg: action.payload.errorMsg
        });
    },
    [fetchAvailableBadges.toString()]: (state, action)=>{
        return _object_spread_props(_object_spread({}, state), {
            awardableBadges: _object_spread_props(_object_spread({}, state.awardableBadges), {
                [action.payload.userId]: {
                    isLoading: true,
                    results: []
                }
            }),
            errorMsg: undefined
        });
    },
    [fetchAvailableBadgesSuccess.toString()]: (state, action)=>{
        return _object_spread_props(_object_spread({}, state), {
            awardableBadges: _object_spread_props(_object_spread({}, state.awardableBadges), {
                [action.payload.userId]: {
                    isLoading: false,
                    results: action.payload.results
                }
            })
        });
    }
}, {});
export default {
    [reduxKey]: handler
};
